import { Template } from "../../constants/MessageActions";
import {
  ConversationModal,
  MessageModal,
} from "../../interfaces/MessageObject";

class ProductDetailHelper {
  static isMyturn(
    conversation: ConversationModal,
    currentUserId: string,
  ): boolean {
    // It's my turn only if last message is from the other user
    const lastMsg = conversation.messages[conversation.messages.length - 1];
    const myTurn = lastMsg ? lastMsg.senderId !== currentUserId : true;
    return myTurn;
  }

  // Helper: returns true if current user is the seller (first message is from buyer)
  static isCurrentUserSeller(
    conversation: ConversationModal,
    currentUserId: string,
  ): boolean {
    const firstMessage = conversation.messages?.[0];
    if (!firstMessage) return false; // default if unknown
    const isCurrentUserBuyer = firstMessage.senderId === currentUserId;
    return !isCurrentUserBuyer;
  }

  // Returns the receiver's name corresponding to the first message in the conversation.
  // It finds the first message from the other participant (different sender) and returns that sender's name.
  static getBuyerSellerName(
    conversation: ConversationModal,
    requireBuyerName: boolean,
  ): string {
    const first = conversation.messages?.[0];
    if (!first) return "";
    return requireBuyerName
      ? (first?.senderName ?? "")
      : (first?.receiverName ?? "");
  }

  static retrieveAllMessagesFromConversation(conversation: ConversationModal) {
    const totalMessages = conversation.messages.length;
    const lastTwoMessagesStartIndex = Math.max(0, totalMessages - 2);
    let allMessages: {
      olderMessages: MessageModal[];
      latestMessages: MessageModal[];
    } = {
      olderMessages: [],
      latestMessages: [],
    };
    allMessages.olderMessages = conversation.messages.slice(
      0,
      lastTwoMessagesStartIndex,
    );
    allMessages.latestMessages = conversation.messages.slice(
      lastTwoMessagesStartIndex,
    );

    return allMessages;
  }

  static getParamsFromUser(
    template: Template,
  ): Record<string, number | null> | null {
    const params: Record<string, number | null> = {};
    // whatever the template param is, it is singular and it needs to be taken via a small popup form which has one single input field and user enters and that should be taken into param
    const param = template.params?.[0];
    if (param) {
      params[param] = Number(prompt(`Enter ${param}`)) || null;
      if (params[param] === null) {
        return null;
      }
    }
    return params;
  }
}

export default ProductDetailHelper;
